import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import gijsImage from "./Gijs.jpg";
import Playlist from "./Playlist";
import orchel from "./fotos/IMG_4489.jpeg";
import Calendar from '@mui/icons-material/CalendarToday';
import Pay from '@mui/icons-material/Payment';

const Home = () => {
  const navigate = useNavigate();

  // State to toggle between concerts
  const [selectedConcert, setSelectedConcert] = useState("oktober");

  return (
    <div> 
      <nav className="navbar">
        <a href="#tickets">Toegangskaarten</a>
        <a href="#gijs">Gijs Boelen</a>
        <a href="#playlist">Playlist</a>
      </nav>

      <div className="hero">
        <img src={orchel} alt="Orgel" className="hero-image" />
        <div className="hero-overlay">  
          <div>
          <h2>Pianoconcert in de Petruskerk Botter Lelystad</h2>
            <p>Op zaterdag 11 april 2026 in Lelystad</p>
            <p>Van 15.30 uur tot 16.30 uur</p>
          </div>
          
          <div>
            <p className="naam-gijs">Pianist : Gijs Boelen</p>
          </div>
          <button className="btn" onClick={() => navigate("/Toegangskaarten")}>
            Toegangskaarten bestellen 
          </button>
        </div>
      </div>

      <div id="tickets">
        <div className="info-section">
          <div className="info-box">
            <h2>Extra informatie</h2>
            <ul>
              <p>1. Evenement Tijdschema</p>
              <li>Deuren Open: 15:00</li>
              <li>Begin concert: 15:30</li>
              <li>Einde concert: 16:30</li>

              <p>2. Locatie Informatie</p>
              <li>Adres: Botter 39 05, 8243 KA Lelystad</li>

              <p>3. Aanvullende Informatie</p>
              <li>Cd's van Gijs zijn te koop voor €15 per stuk.</li>
              {/* <li>Het orgel is gebouwd in 1897 door Daniel Gerard Steenkuyl</li> */}
            </ul>
          </div>
          <div className="price-box">
              {/* --- All price info for Lelystad here --- */}
              <h2>Toegangskaarten</h2>
              <p><strong>€10,00</strong></p>
              <p>Botter 39 05, 8243 KA Lelystad</p>
                <button className="btn-ticket" onClick={() => navigate("/Toegangskaarten")}>Toegangskaarten bestellen </button>
              <p>Kinderen tot 12 jaar gratis</p>
            </div>
        </div>
      </div>

      <div className="performer-section" id="gijs">
        <div className="performerContainer">
          <div className="performer-text">
            <h2>Gijs Boelen</h2>
            <p>
             Gijs Boelen speelt Nederlandse pianomuziek, waarvan de helft eigen composities. 
             Carel Anton Fodor liet zich voor zijn heldere en optimistische eerste pianosonate 
             inspireren door bekende tijdgenoten als Haydn en Mozart. Samuel de 
             Lange jr. was een echte romanticus. Van hem speelt hij twee dromerige, 
             sprookjesachtige nocturnes. De eigentijdse composities van Gijs Boelen zijn in de basis enigszins
              minimalistisch en daarnaast ook heel kleurrijk. Van Indonesische gamelan tot zigeunermuziek tot house, 
              er komt van alles voorbij.
            </p>
            <a href="https://www.gijsboelen.nl/">Gijs Boelen - Orgel & Compositie</a>
          </div>
          <div className="performer-image">
            <img src={gijsImage} alt="Gijs Boelen" />  
            <div className="performer-overlay">
              <p>Foto: Adrienne Korzilius</p>
            </div>
          </div>
        </div>
      </div>

      <div id="playlist">
        <Playlist />
      </div>
    </div>
  );
};

export default Home;
